import React from 'react';
import Dropdown from '@src/framework/frame-pc/components/dropdown';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import LinkEditMenu from '@src/slide/application/service/link-manager/core/link-edit-menu';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { ILinkEditMenuService, ILinkManager } from '@src/slide/application/service/link-manager/core/link-manager.interface';

export class LinkEditMenuService implements ILinkEditMenuService {
    private DropdownOp: ReturnType<typeof Dropdown.create> | null;

    public constructor(
        private uiDataService: IUiDataService,
        private linkManager: ILinkManager,
        public menuManager?: IMenuManager,
    ) {}

    public show(config) {
        if (!this.DropdownOp) {
            const point = config.anchorPoint;
            this.DropdownOp = Dropdown.create({
                anchorPoint: point,
                anchorRect: config.anchorRect,
                center: true,
                autoAlign: true,
                hasShadow: false,
                scrollable: false,
                hasTransform: false,
                isTransparent: true,
                onVisibleChange: (visible) => {
                    if (this.menuManager) {
                        if (visible) {
                            this.menuManager.isMenuShown = true;
                        } else {
                            this.menuManager.isMenuShown = false;
                        }
                    }
                    if (!visible) this.hide();
                    if (config.handleVisibleChange) {
                        config.handleVisibleChange(visible);
                    }
                },
                dropContent: <LinkEditMenu
                    data={config.data}
                    anchorRect={point ? {
                        x: point.x, y: point.y, width: 0, height: 0,
                    } : config.anchorRect}
                    handleLinkEdit={config.handleLinkEdit}
                    isTextLink={config.isTextLink}
                    uiDataService={this.uiDataService}
                    getInnerLinkInfo={this.linkManager.getInnerLinkInfo}
                    handleDropDsiable = {disable => this.DropdownOp?.setDisable(disable)}
                    hide={this.hide.bind(this)}
                />,
            });
        }
        this.DropdownOp.show();
    }

    public hide() {
        if (this.DropdownOp) {
            this.DropdownOp.close();
            this.DropdownOp = null;
        }
    }

    public isShown() {
        if (this.DropdownOp) {
            return this.DropdownOp.isShown();
        }
        return false;
    }
}
